import { FC } from "react";
import { FooterLink } from "./types";
import { FooterLinkItem } from "./FooterLinkItem";

interface Props {
  links: FooterLink[];
}

export const FooterLinks: FC<Props> = ({ links }) => (
  <ul className="flex flex-col gap-4">
    {links.map(({ id, ...link }) => (
      <FooterLinkItem key={id} {...link} />
    ))}
  </ul>
);
